/**
 * 定义公司--》架构设置
 */

 export default {
  // 网点 表单添加网点简称 https://imagecdn.ymm56.com/ymmfile/static/resource/748d0431-16a7-4c24-b562-d32cf93eb9a0.png
  site_add_abbreviation: ['99259'], // 202509221605212235354
  // 操作员代码长度支持 50位
  company_operator_code_50: ['83158'], // 202512041609171302671
}
